/**
 * valumize API for managing funds
 * Lorem ipsum ...
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AiSetupOverwriteMode = 'FILL_BLANKS_ONLY' | 'REGENERATE_AI_FIELDS' | 'REGENERATE_ALL';

export const AiSetupOverwriteMode = {
    FillBlanksOnly: 'FILL_BLANKS_ONLY' as AiSetupOverwriteMode,
    RegenerateAiFields: 'REGENERATE_AI_FIELDS' as AiSetupOverwriteMode,
    RegenerateAll: 'REGENERATE_ALL' as AiSetupOverwriteMode
};

